import * as React from 'react';
import styled from 'styled-components';
import Image, { ImageProps as NextImageProps } from 'next/image';
import addHttpsProtocol from '@mybet/core/utils/addHttpsProtocol';
import ScaleDown3d from '@mybet/core/components/Animations/ScaleDown3d';
import useMatchMedia from '@mybet/core/utils/useMatchMedia';

const BannerRoot = styled.div({
  position: 'relative',
  width: '100%',
  minHeight: 100,
});

const BannerImageRoot = styled.div((props) => ({
  ...props.theme.mixins.absoluteFill,
  backgroundColor: props.theme.blue15,
  zIndex: -1,
  overflow: 'hidden',
}));

export type BannerProps = {
  animate?: boolean;
  imageSrc?: string;
  ImageProps?: Omit<
    NextImageProps,
    'src' | 'width' | 'height' | 'layout' | 'objectFit'
  >;
};

const Banner: React.FC<BannerProps> = (props) => {
  const { imageSrc, children, ImageProps, animate = true } = props;
  const { matches: smMatches } = useMatchMedia('sm');

  return (
    <BannerRoot>
      <BannerImageRoot>
        {imageSrc && (
          <ScaleDown3d duration={!animate ? '0s' : smMatches ? '18s' : '10s'}>
            <Image
              {...ImageProps}
              alt="Banner image"
              src={addHttpsProtocol(imageSrc)}
              objectFit="cover"
              layout="fill"
              priority
            />
          </ScaleDown3d>
        )}
      </BannerImageRoot>
      {children}
    </BannerRoot>
  );
};

export default Banner;
